import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface HelpContextType {
  helpMode: boolean;
  setHelpMode: (enabled: boolean) => void;
  toggleHelpMode: () => void;
  activeTooltip: string | null;
  setActiveTooltip: (key: string | null) => void;
}

const HelpContext = createContext<HelpContextType | undefined>(undefined);

interface HelpProviderProps {
  children: ReactNode;
}

export const HelpProvider: React.FC<HelpProviderProps> = ({ children }) => {
  const [helpMode, setHelpMode] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

  const toggleHelpMode = useCallback(() => {
    setHelpMode(prev => !prev);
    if (helpMode) {
      setActiveTooltip(null);
    }
  }, [helpMode]);

  const value: HelpContextType = {
    helpMode,
    setHelpMode,
    toggleHelpMode,
    activeTooltip,
    setActiveTooltip,
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = (): HelpContextType => {
  const context = useContext(HelpContext);
  if (context === undefined) {
    throw new Error('useHelp must be used within a HelpProvider');
  }
  return context;
};

export default HelpContext;

